import { Link } from 'react-router-dom';
import { TrendingUp, Briefcase, ArrowRight, Percent, Zap } from 'lucide-react';

const calculadoras = [
  {
    href: '/calculadoras/r2r',
    icon: TrendingUp,
    iconBg: 'bg-blue-600',
    title: 'Rent to Rent (R2R)',
    description: 'Evalúa la viabilidad y rentabilidad de tu modelo híbrido vacacional/media estancia. Calcula el beneficio neto, payback, ROI y la renta máxima recomendada.',
    tags: ['Viabilidad', 'Payback', 'ROI', 'Contrato'],
    tagColor: 'bg-blue-50 text-blue-700',
  },
  {
    href: '/calculadoras/gestion',
    icon: Briefcase,
    iconBg: 'bg-emerald-600',
    title: 'Gestión & Explotación',
    description: 'Compara los modelos de gestión y explotación turística. Analiza rentabilidad, liquidaciones fiscales, reparto con propietarios y capacidad de contratación.',
    tags: ['Gestión', 'Explotación', 'Fiscal', 'RRHH'],
    tagColor: 'bg-emerald-50 text-emerald-700',
  },
  {
    href: '/calculadoras/ota',
    icon: Percent,
    iconBg: 'bg-amber-600',
    title: 'Comisiones OTA',
    description: 'Calcula el markup necesario para igualar ganancias entre venta directa y OTAs (Booking, Airbnb). Incluye Genius y gráfico comparativo.',
    tags: ['Markup', 'Booking', 'Airbnb', 'Genius'],
    tagColor: 'bg-amber-50 text-amber-700',
  },
  {
    href: '/calculadoras/luz',
    icon: Zap,
    iconBg: 'bg-purple-600',
    title: 'Reparto de luz',
    description: 'Divide una factura de luz entre inquilinos: los costes fijos a partes iguales y la energía según los kWh que ha gastado cada uno.',
    tags: ['Inquilinos', 'Fijos', 'Consumo', 'IVA'],
    tagColor: 'bg-purple-50 text-purple-700',
  },
];

export default function CalculadorasPage() {
  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-sereno-dark">Calculadoras</h1>
        <p className="text-slate-500 mt-1">Herramientas financieras para analizar rentabilidad y estrategia.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {calculadoras.map((calc) => (
          <Link
            key={calc.href}
            to={calc.href}
            className="group bg-white rounded-2xl border border-slate-200 p-6 shadow-sm hover:shadow-md hover:border-slate-300 transition-all flex flex-col gap-4"
          >
            <div className="flex items-center gap-4">
              <div className={`${calc.iconBg} p-3 rounded-xl text-white shrink-0`}>
                <calc.icon size={24} />
              </div>
              <h2 className="text-lg font-semibold text-sereno-dark">{calc.title}</h2>
            </div>
            <p className="text-sm text-slate-500 leading-relaxed flex-1">{calc.description}</p>
            <div className="flex items-center justify-between">
              <div className="flex flex-wrap gap-1.5">
                {calc.tags.map((tag) => (
                  <span key={tag} className={`text-xs font-medium px-2 py-0.5 rounded-full ${calc.tagColor}`}>
                    {tag}
                  </span>
                ))}
              </div>
              <ArrowRight size={18} className="text-slate-400 group-hover:text-slate-700 group-hover:translate-x-0.5 transition-all shrink-0" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
